const relativePath = process.env.REACT_APP_BASE_LEGACY_URL ?? "";

export const openLegacyUrl = (path: string) => {
    window.open(`${relativePath}${path}`, "_blank");
};
